import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_REPORT_PROBLEM_REQUEST =
  'UserAnnouncement/FETCH_REPORT_PROBLEM_REQUEST'
const FETCH_REPORT_PROBLEM_SUCCESS =
  'UserAnnouncement/FETCH_REPORT_PROBLEM_SUCCESS'
const FETCH_REPORT_PROBLEM_FAILURE =
  'UserAnnouncement/FETCH_REPORT_PROBLEM_FAILURE'

const UPDATE_REPORT_PROBLEM_REQUEST = 'UserAnnouncement/UPDATE_REPORT_PROBLEM_REQUEST'
const UPDATE_REPORT_PROBLEM_SUCCESS = 'UserAnnouncement/UPDATE_REPORT_PROBLEM_SUCCESS'
const UPDATE_REPORT_PROBLEM_FAILURE = 'UserAnnouncement/UPDATE_REPORT_PROBLEM_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  reportProblemList: { content: [], pageable: {} }
}

// Default Reducer
const reportProblem = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REPORT_PROBLEM_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_REPORT_PROBLEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        reportProblemList: action.payload
      }
    case FETCH_REPORT_PROBLEM_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
      case UPDATE_REPORT_PROBLEM_REQUEST:
        return {
          ...state,
          isLoading: true
        }
      case UPDATE_REPORT_PROBLEM_SUCCESS:
        return {
          ...state,
          isLoading: false
        }
      case UPDATE_REPORT_PROBLEM_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false
        }
    default:
      return state
  }
}

export default reportProblem

// Action Creators
export const fetchReportProblemList = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_REPORT_PROBLEM_REQUEST
      })
      const params = new URLSearchParams()
      if (options.keyword) params.append('keyword', options.keyword)
      if (options.status) params.append('status', options.status)
      if (options.type) params.append('type', options.type)
      params.append('page', options.page)
      params.append('size', options.size)

      const { data } = await API.get(EndPoints.REPORT_PROBLEM + `/search`, {
        params: params
      })
      dispatch({
        type: FETCH_REPORT_PROBLEM_SUCCESS,
        payload: data
      })
    } catch (err) {
      dispatch({
        type: FETCH_REPORT_PROBLEM_FAILURE
      })
    }
  }
}
export const updateReportProblemReport = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_REPORT_PROBLEM_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.REPORT_PROBLEM+ `/updateProblemReportStatus`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_REPORT_PROBLEM_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_REPORT_PROBLEM_FAILURE
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/modules/reportProblem.js